import * as XLSX from 'xlsx';
import { useUserStore } from '@/lib/user-store';
import { useOwnerStore } from '@/lib/owner-store';

export const exportTasksToExcel = (tasks: any[]) => {
  const { users } = useUserStore.getState();
  const { owners } = useOwnerStore.getState();

  // Convert tasks to worksheet format
  const worksheet = XLSX.utils.json_to_sheet(tasks.map(task => {
    // Find owner information
    let ownerName = 'Unknown';
    if (task.owner_id) {
      const owner = owners.find(o => o.id === task.owner_id);
      ownerName = owner?.name || 'Unknown';
    }

    // Find user information (created by)
    let userName = 'Unknown';
    if (task.created_by) {
      const user = users.find(u => u.id === task.created_by);
      userName = user?.full_name || 'Unknown';
    }

    return {
      Title: task.title,
      Description: task.description || '',
      Category: task.category,
      Status: task.status,
      Priority: task.priority,
      Due_Date: task.due_date ? new Date(task.due_date).toLocaleDateString() : '',
      Owner: ownerName,
      Created_By: userName,
      Created_At: task.created_at ? new Date(task.created_at).toLocaleDateString() : '',
      Updated_At: task.updated_at ? new Date(task.updated_at).toLocaleDateString() : ''
    };
  }));

  // Create workbook and append worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Tasks');

  // Generate Excel file with timestamp and filter indication
  const timestamp = new Date().toISOString().split('T')[0];
  const filename = `tasks_export_${timestamp}_filtered.xlsx`;
  XLSX.writeFile(workbook, filename);
};
